import { usePage } from '@inertiajs/vue3';
import AccountData = App.Data.AccountData;

const page = usePage();

export default (account: AccountData, options: { settingsPage?: string, reportId?: string } = { settingsPage: 'report-content', reportId: '' }) => {
  const referrerLink = options.reportId ? `${page.props.config['spectre-id'].host}/reports/${options.reportId}/edit` : `${page.props.app.url}/settings/${options.settingsPage}/edit?account=${account.id}`;

  return `${page.props.config['spectre-id'].host}/settings/accounts/${account.spectreAccountId}/edit?referrer=${referrerLink}`;
};
